<div class="gov-enabler-pillars">
    <div class="gov-enabler-pillars__header">
        <div class="gov-enabler-pillars__heading">
            <h5 class="gov-enabler-pillars__title">
                {{ "landingPage.entity_page.government_enabler_pillars" | translate }}
                <span class="gov-enabler-pillars__period">{{ periodLabel() }}</span>
            </h5>
        </div>

        <adaa-chart-action-buttons
            [elementId]="''"
            [elementIds]="elementIds()"
            [chartTitles]="chartTitles()"
            [extraContent]="extraContent()"
            [enableDownloadImage]="false"
        ></adaa-chart-action-buttons>
    </div>

    <div class="gov-enabler-pillars__grid">
        @for (pillar of pillars(); track pillar.id; let index = $index) {
            <div class="gov-enabler-pillars__card">
                <button type="button" class="gov-enabler-pillars__name" (click)="goToEkpi(pillar.id)">
                    {{ pillar | translateToken: "pillarName" }}
                </button>

                <div class="gov-enabler-pillars__score-row">
                    <span class="gov-enabler-pillars__ring" #ring>
                        <adaa-pillar-performance-graph
                            [data]="pillar"
                            [chartId]="'enablerChart' + index"
                            [activeEkpiId]="activeEkpiId(pillar.id)"
                            (segmentHovered)="hoverEkpi(pillar, $event, ring)"
                            (segmentClicked)="goToEkpi($event)"
                        />
                    </span>

                    <div class="gov-enabler-pillars__score-block">
                        <span class="gov-enabler-pillars__caption">{{ "data_entry.performance" | translate }}</span>
                        <span class="gov-enabler-pillars__score" [style.color]="pillarColor(pillar)">
                            {{ pillar.pillarPerformance | percentageValue }}
                        </span>
                    </div>
                </div>

                <span class="gov-enabler-pillars__divider"></span>

                <adaa-pillar-ekpi-info
                    [ekpiList]="pillar.ekpiList"
                    [activeEkpiId]="activeEkpiId(pillar.id)"
                    (kpiListContent)="setContent($event)"
                    (ekpiHovered)="hoverEkpi(pillar, $event, ring)"
                    (ekpiClicked)="goToEkpi($event)"
                />
            </div>
        }
    </div>
</div>

@if (tooltip(); as tip) {
    <div class="pillar-tooltip" [class.pillar-tooltip--below]="tip.below" [style.left.px]="tip.x" [style.top.px]="tip.y">
        <span class="pillar-tooltip__name">{{ tip.name }}</span>

        <span class="pillar-tooltip__row">
            <span class="pillar-tooltip__swatch" [style.background-color]="tip.color"></span>
            <span class="pillar-tooltip__value">{{ tip.value }}</span>
            <span class="pillar-tooltip__bar">
                <span [style.width.%]="tip.pct" [style.background-color]="tip.color"></span>
            </span>
        </span>
    </div>
}
